import { EProductPriority } from 'constants/enums';

export const MAX_PRODUCTS_PER_MILESTONE = 3;

export const MILESTONE_PRODUCT_TYPE_OPTIONS = [
  EProductPriority.MAIN,
  EProductPriority.SUB
].map((priority) => ({ value: priority, label: priority }));
